// Mixin for FiatCard.vue
export default {
  props: {
    cards: {
      type: Object,
      default: () => {},
    },
    backgroundColor: {
      type: String,
      default: '',
    },
    backgroundImg: {
      type: String,
      default: '',
    },
    iconCard: {
      type: String,
      default: '',
    },
    cardNumber: {
      type: String,
      default: '',
    },
    depositLink: {
      type: String,
      default: '',
    },
    widrawLink: {
      type: String,
      default: '',
    },
    historyLink: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // Empty data object as placeholder
    }
  },
}
